import { DataText } from './data-text';
import { NumberOrEmpty } from './number-or-empty';

type QuantityTextProps = {
    quantity: number | undefined | null;
    unit: string | undefined | null;
};

export const QuantityText = ({ quantity, unit }: QuantityTextProps) => {
    return (
        <span>
            <DataText>
                <NumberOrEmpty>{quantity}</NumberOrEmpty>
            </DataText>
            {unit && ` ${unit}`}
        </span>
    );
};
